import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.071263 6.21112L2.99301 0.368498C3.23873 -0.122853 3.93993 -0.122811 4.18558 0.36857L7.10645 6.21119C7.32805 6.65446 7.00572 7.17596 6.51015 7.17596H0.66753C0.171925 7.17596 -0.150405 6.65439 0.071263 6.21112Z",
		fill: "#525252"
	})
});
export default SvgArrowUp;
